export const AVERAGE_CAPACITY_USAGE = 3500
export const MAX_SOLAR_KVA = 10
